import React from "react"
import "./callScoreFactorDetails.scss";
import PropTypes from "prop-types";
import FactorTitleAndScore from "./FactorTitleAndScore";
import {QUESTIONS} from "./callScoreHelpers";

const QuestionAnswer = ({question, answer, className}) => {
  return <div className={`call-score-question-answer ${className}`}>
      <p className={"question"}>{question}</p>
      <p className={"answer"}>{answer}</p>
  </div>
};
const Summary = ({ summary }) => {
    return <div className="criteria-summary">{summary}</div>
}
const CallScoreFactorDetails = ({title, actualScore, totalScore, whatWorked, whatDidNotWork, howCouldItBeImproved, summary}) => {
return !!whatWorked || !!whatDidNotWork || !!howCouldItBeImproved ? <div className={"factor-details white-background-container"}>
        <FactorTitleAndScore title={title} actual={actualScore} total={totalScore} />
        {
            summary && <Summary summary={summary} />
        }
        {
            whatWorked && <QuestionAnswer question={QUESTIONS.WHAT_WORKED} answer={whatWorked} className={"what-worked-well"} />
        }
        {
            whatDidNotWork && <QuestionAnswer question={QUESTIONS.WHAT_DID_NOT_WORK} answer={whatDidNotWork} className={"what-did-not-work"} />
        }
        {
            howCouldItBeImproved && <QuestionAnswer question={QUESTIONS.HOW_COULD_IT_BE_IMPROVED} answer={howCouldItBeImproved} className={"how-could-it-be-improved"} />
        }
    </div>
        : <></>
}
CallScoreFactorDetails.prototype = {
    title: PropTypes.string,
    actualScore: PropTypes.number,
    totalScore: PropTypes.number,
    whatWorked: PropTypes.string,
    whatDidNotWork: PropTypes.string,
    howCouldItBeImproved: PropTypes.string
}

export default CallScoreFactorDetails;